<script>
    import {elementBodyClickListener} from '../lib/body-click-listener-helper'
    import uniqueId from 'lodash/uniqueId'
    import {nextTick} from "vue";
    export default {
        name: 'ks-select',
        props: ['show'],
        data () {
            return {
                name: uniqueId('ks-select'),
                contextClickListener: null,
                viewContext: false,
                ctxLeft: 0,
            }
        },
        mounted() {
            this.contextClickListener = elementBodyClickListener(this, this.name, 'viewContext');
        },
        created() {
            this.name = uniqueId('ks-select');
        },
        methods: {
            showContext(e){
                if(!this.viewContext){
                    this.viewContext = true;
                    this.setPositionFromEvent(e.currentTarget);
                    this.contextClickListener.start();
                }else{
                    this.viewContext = false;
                }
            },
            setPositionFromEvent(el) {
                let self = this;
                nextTick(() => {
                    let left = 0;
                    if (el.offsetLeft + (self.$refs[self.name].offsetWidth + 5) <= window.innerWidth) {
                        left = el.offsetLeft + 5;
                    } else {
                        left = el.offsetLeft + el.offsetWidth - (self.$refs[self.name].offsetWidth);
                    }

                    self.ctxLeft = left;
                });
            },

        },
        computed: {
            contextMenuStyle () {
                return {
                    'display': this.viewContext ? 'block' : 'none',
                    'left': (this.ctxLeft || 0) + 'px'
                }
            },
        },
    }
</script>
<template>

    <div :ref="name">
        <div @click="showContext" style="cursor: pointer;"><slot name="target"></slot></div>
        <slot name="body" v-if="viewContext"></slot>
    </div>


</template>
